<div class="group3">
  <h4 style="margin-top: 0;" *ngIf="!hidetitle"> Infos Fact. </h4>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht42">
    <label class="col-sm-3 champ" style="padding:0px"> Nom Fact. :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{chantier.nomChantierFact}}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.nomChantierFact">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht43 || common.visibleChamp.cht44 || common.visibleChamp.cht45">
    <label class="col-sm-3 champ" style="padding:0px"> Adresse Fact :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cht43">{{ chantier.adresse1ChantierFact }}</div>
      <div *ngIf="!edit && common.visibleChamp.cht44">{{ chantier.adresse2ChantierFact }}</div>
      <div *ngIf="!edit && common.visibleChamp.cht45">{{ chantier.adresse3ChantierFact }}</div>
      <div *ngIf="edit && common.visibleChamp.cht43">
        <app-autocomplete *ngIf="adresseAutoBAK" [placeholder]="'Adresse'" (searchfunction)="searchAdresseBAK($event)"
          (selectfunction)="setValueAdresseBAK($event, 'client')" [results]="dataAdresseBAK" [container]="true"
          [defaultsearch]="chantier.adresse1ChantierFact ? chantier.adresse1ChantierFact : ''" [minlength]="3"  [nePasCompterEspace]="true">
        </app-autocomplete>
        <input *ngIf="edit && !adresseAutoBAK" type="text" class="form-control"
          [(ngModel)]="chantier.adresse1ChantierFact" [readonly]="adresseAutoBAK">
      </div>
      <!--input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.adresse1ChantierFact" [readonly]="adresseAutoBAK" -->
      <input *ngIf="edit && common.visibleChamp.cht44" type="text" class="form-control" [(ngModel)]="chantier.adresse2ChantierFact"
        style="margin-top: 5px; margin-bottom: 5px;" [readonly]="adresseAutoBAK">
      <input *ngIf="edit && common.visibleChamp.cht45" type="text" class="form-control" [(ngModel)]="chantier.adresse3ChantierFact"
        [readonly]="adresseAutoBAK">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht46">
    <label class="col-sm-3 champ" style="padding:0px"> CP Fact. : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.CPChantierFact }}</div>
      <!-- <div *ngIf="edit" class="btn-group" dropdown style="width:100%;" [autoClose]="true" [isOpen]="status.iscp"
        (isOpenChange)="change($event, true)" (blur)="toggleDropdown">
        <input type="text" class="form-control" id="cp" [(ngModel)]="chantier.CPChantierFact"
          (ngModelChange)="searchCPVille(chantier.CPChantierFact, true)" autocomplete="new-password" />
        <ul *dropdownMenu class="dropdown-menu cpville" role="menu">
          <li role="menuitem" *ngFor="let item of resultCpVille; let i = index;" class="items"
            (click)="selectAdresse(item)">
            <a class="dropdown-item">
              {{ item.codePostal + ' / ' + item.ville}}
            </a>
          </li>
        </ul>
      </div> -->

      <div *ngIf="edit">
        <app-autocomplete-cp-ville [cp]="'CPChantierFact'" [item]="chantier" [ville]="'villeChantierFact'"  [iscp]="true"
          [disable]="adresseAutoBAK">
        </app-autocomplete-cp-ville>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht47">
    <label class="col-sm-3 champ" style="padding:0px"> Ville Fact. : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{chantier.villeChantierFact}}</div>
      <!-- <div *ngIf="edit" class="btn-group" dropdown style="width:100%;" [autoClose]="true" [isOpen]="status.isville"
        (isOpenChange)="change($event)" (blur)="toggleDropdown">
        <input type="text" class="form-control" id="ville" [(ngModel)]="chantier.villeChantierFact"
          (ngModelChange)="searchCPVille(chantier.villeChantierFact)" autocomplete="new-password" />
        <ul *dropdownMenu class="dropdown-menu cpville" role="menu">
          <li role="menuitem" *ngFor="let item of resultCpVille; let i = index;" class="items"
            (click)="selectAdresse(item)">
            <a class="dropdown-item">
              {{ item.codePostal + ' / ' + item.ville}}
            </a>
          </li>
        </ul>
      </div> -->

      <div *ngIf="edit">
        <app-autocomplete-cp-ville [cp]="'CPChantierFact'" [item]="chantier" [ville]="'villeChantierFact'" 
          [disable]="adresseAutoBAK">
        </app-autocomplete-cp-ville>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht48">
    <label class="col-sm-3 champ" style="padding:0px"> TVA Intracom : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{chantier.codeTVAIntra}}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.codeTVAIntra">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht49">
    <label class="col-sm-3 champ" style="padding:0px"> Mail : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{chantier.mailFact}}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.mailFact" (keydown)="common.filterCarracterEmail($event)">
    </div>
  </div>
</div>